export default __webpack_public_path__ + "static/media/bathroom2-afterA-1920w.fba5c979.png";